import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

// Detect default language based on browser settings or timezone
const getDefaultLanguage = () => {
  if (typeof window === 'undefined') return 'en';
  
  // Check if user has a saved preference
  const savedLanguage = localStorage.getItem('language');
  if (savedLanguage) return savedLanguage;
  
  // Check browser language
  const browserLang = navigator.language || navigator.userLanguage;
  if (browserLang && browserLang.toLowerCase().startsWith('id')) {
    return 'id';
  }
  
  // Check timezone for Indonesia (Asia/Jakarta, Asia/Makassar, Asia/Jayapura, etc.)
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (timezone && timezone.toLowerCase().includes('asia/jakarta') || 
        timezone.toLowerCase().includes('asia/makassar') ||
        timezone.toLowerCase().includes('asia/jayapura') ||
        timezone.toLowerCase().includes('asia/pontianak')) {
      return 'id';
    }
  } catch (e) {
    // Timezone detection not supported
  }
  
  return 'en';
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(getDefaultLanguage);

  useEffect(() => {
    localStorage.setItem('language', language);
    document.documentElement.lang = language;
  }, [language]);

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'id' : 'en');
  };

  const t = (enText, idText) => {
    return language === 'en' ? enText : idText;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
